<template>
  <fragment>
    <div v-if="enforceShowLoader" :style="{ height: iframeHeight }">
      <Preloader />
    </div>
    <template v-else>
      <iframe
        :src="computedUrl"
        class="iframe"
        :style="{
          height: iframeHeight
        }"
        type="application/pdf"
        @load="isDocumentLoading = false"
      ></iframe>
    </template>
  </fragment>
</template>

<script>
import Preloader from '@components/Preloader.vue'

export default {
  name: 'DocumentPreviewIFrame',
  components: { Preloader },
  props: {
    // Sometimes we want the parent component to take control of loader visibility
    enforceShowLoader: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      required: true
    },
    iframeHeight: String,
    toolbar: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isDocumentLoading: true
    }
  },
  computed: {
    computedUrl () {
      return `${this.url}${this.toolbar ? '' : '#toolbar=0'}`
    }
  }
}
</script>

<style scoped lang="scss">
.iframe {
  border: 0;
  width: 100%;
  aspect-ratio: 1 / 1.414;

  &.invoice-form-preview-cont__in-modal {
    height: calc(100vh - 160px);
  }
}
</style>
